import { render, staticRenderFns } from "./CustomerPortfolioView_v2.vue?vue&type=template&id=6073c78e"
import script from "./CustomerPortfolioView_v2.vue?vue&type=script&lang=js"
export * from "./CustomerPortfolioView_v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@6.26.3_css-loader@6.11.0_webpack_803fd858e391fe10e6ea2ea3dda7e9cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports